/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledProposalCancellationsRequest model module.
 * @module model/ScheduledProposalCancellationsRequest
 * @version 1.0.0
 */
class ScheduledProposalCancellationsRequest {
    /**
     * Constructs a new <code>ScheduledProposalCancellationsRequest</code>.
     * @alias module:model/ScheduledProposalCancellationsRequest
     * @param proposalDate {Date} 取り消す予約日時。scheduled_dates が返した値と完全一致するものだけを取り消す。
     */
    constructor(proposalDate) { 
        
        ScheduledProposalCancellationsRequest.initialize(this, proposalDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, proposalDate) { 
        obj['proposal_date'] = proposalDate;
    }

    /**
     * Constructs a <code>ScheduledProposalCancellationsRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledProposalCancellationsRequest} obj Optional instance to populate.
     * @return {module:model/ScheduledProposalCancellationsRequest} The populated <code>ScheduledProposalCancellationsRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledProposalCancellationsRequest();

            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledProposalCancellationsRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledProposalCancellationsRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ScheduledProposalCancellationsRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

ScheduledProposalCancellationsRequest.RequiredProperties = ["proposal_date"];

/**
 * 取り消す予約日時。scheduled_dates が返した値と完全一致するものだけを取り消す。
 * @member {Date} proposal_date
 */
ScheduledProposalCancellationsRequest.prototype['proposal_date'] = undefined;






export default ScheduledProposalCancellationsRequest;

